export const SHOW_SCREEN_LOADER = 'SHOW_SCREEN_LOADER'
export const HIDE_SCREEN_LOADER = 'HIDE_SCREEN_LOADER'

export const SHOW_TOAST = 'SHOW_TOAST'
export const HIDE_TOAST = 'HIDE_TOAST'
